// extracted by mini-css-extract-plugin
export default {"progress_container":"NutritionalProgressContainer_progress_container__2h4zc"};